<template>
	<div>
		<!-- 底部 -->
		<div class="w-footer">
			<div class="w-width flex vc">
				<div class="footer_container flex hb vc">
					<img src="../../assets/img/index/logo2.png" alt="" class="w-footerlogo" ondragstart="return false">
					<img src="../../assets/img/index/footershu.png" alt="" class="w-footershu" ondragstart="return false">

          <ul class="w-footerul">
						<li>电话：0351-2051369</li>
						<li>Email：SXNUEDF@163.com</li>
						<li>
              <span>地址：中国·山西·太原 小店区太榆路339号 邮编：030031</span>
              <a class="footer_icon_box" href="http://bszs.conac.cn/sitename?method=show&id=0ADF13855C1A222BE053012819AC6888" target="_blank">
                <img class="footer_icon" src="../../assets/img/icon/icon_1.png" alt="">
              </a>
              <a class="footer_icon_box" href="http://www.beian.gov.cn/portal/index" target="_blank">
                <img class="footer_icon" src="../../assets/img/icon/icon_2.png" alt="">
              </a>
              <a class="footer_icon_box" href="http://202.99.219.148/alarm/" target="_blank">
                <img class="footer_icon" src="../../assets/img/icon/icon_3.png" alt="">
              </a>
            </li>
						<li>Copyright© 山西师范大学教育发展基金会 版权所有</li>
            <li>
              <span>晋ICP备08000157号</span>
              <a class="footer_icon_box_copy" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14100202000166" target="_blank">
                <img class="footer_icon" src="../../assets/img/icon/icon_police.png" alt="">
              </a>
              <span>晋公网安备  14100202000166号</span>
            </li>
					</ul>

          <div class="erbox flex he">
            <img src="../../assets/img/index/er.png" alt="" class="w-erimg" @click="showDialog">
            <p class="w-er">
              <span>扫码关注</span>
              <span style="margin-top: 10px">山西师范大学</span>
              <span>教育发展基金会</span>
            </p>
          </div>
          <img src="../../assets/img/index/footershu.png" alt="" class="w-footershu" ondragstart="return false">

          <div class="flex column vc link_box">
            <span style="margin-bottom: 10px;">友情链接</span>
            <span class="flex column vs">
            <a href="http://rucef.ruc.edu.cn/index.php" target="_blank" class="w-link">中国人民大学教育发展基金会</a>
            <a href="http://www.bnuef.org/" target="_blank" class="w-link">北京师范大学教育发展基金会</a>
            <a href="http://jjh.swu.edu.cn/" target="_blank" class="w-link">西南大学教育发展基金会</a>
            <a href="http://edfwx.njnu.edu.cn/wechat/website/index.do" target="_blank" class="w-link">南京师范大学教育发展基金会</a>
            <a href="http://jyfzjjh.jiangnan.edu.cn/" target="_blank" class="w-link">江南大学教育发展基金会</a>
            </span>
          </div>
        </div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Footer",

    methods: {
      showDialog() {
        // 事件触发 显示捐赠模态框
        this.$eventBus.$emit('isShowCodeDialog', true, false)
      }
    }
	}
</script>

<style scoped>
.footer_icon_box {
  margin-left: 10px;
}

.footer_icon_box_copy {
  margin: 0 5px;
}

.footer_icon {
  height: 10PX;
}
</style>

<style scoped>
	.w-width {
    min-width: 600PX;
		width: 70%;
		margin: 0 auto;
	}

  .footer_container {
    width: 100%;
    padding: 0 10px;
  }

	.w-footer {
		background: rgb(118, 42, 42);
		padding-top: 30px;
		padding-bottom: 25px;
	}

	.w-footerlogo {
		height: 60PX;
		display: block;
    user-select: none;
	}

	.w-footerul {
		font-size: 14px;
		color: #fff;
		line-height: 1.6;
	}

	.w-footershu {
		height: 40PX;
	}

  .link_box {
    font-size: 14px;
    color: #fff;
  }

	.w-link {
		font-size: 14px;
		color: #fff;
	}

  .w-link:hover {
    color: #e6a23c;
  }

	.w-erimg {
		width: 80PX;
		display: block;
		padding: 4px;
		border: 1PX solid #fff;
    cursor: pointer;
    box-sizing: border-box;
	}

	.erbox {
		margin-left: 25px;
	}

	.erbox p span {
		display: block;
		text-align: center;
		color: #fff;
		font-size: 14px;
	}
	.w-er {
		margin-left: 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue